import { createReducer } from '@reduxjs/toolkit';

import postEasyPostShipment from '../../../thunks/shipment/easyPost/postEasyPostShipment';
import postEasyPostShipmentClearError from '../../../actions/shipment/easyPost/postEasyPostShipment';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const postEasyPostShipmentReducer = createReducer(initialState, {
  [postEasyPostShipment.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [postEasyPostShipment.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [postEasyPostShipment.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: undefined
  }),
  [postEasyPostShipmentClearError]: (state) => ({
    ...state,
    error: null,
  }),

});

export default postEasyPostShipmentReducer;
